import { useState, useEffect } from "react";
import { API } from "@/lib/api";
import { X, DownloadSimple } from "@phosphor-icons/react";

export default function FilePreview({ fileId, filename, ext, contentType, onClose }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("fcf_token");
  const downloadUrl = `${API}/files/${fileId}/download?auth=${token}`;

  useEffect(() => {
    const isPreviewable = ["pdf", "png", "jpg", "jpeg", "webp", "gif"].includes((ext || "").toLowerCase());
    if (!isPreviewable) { setError("Anteprima non disponibile per questo formato"); return; }
    let url;
    fetch(downloadUrl)
      .then((r) => r.blob())
      .then((b) => { url = URL.createObjectURL(b); setBlobUrl(url); })
      .catch((e) => setError(e.message));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId, ext, downloadUrl]);

  const isImage = ["png", "jpg", "jpeg", "webp", "gif"].includes((ext || "").toLowerCase());
  const isPdf = ext?.toLowerCase() === "pdf";

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/70 backdrop-blur-sm flex items-center justify-center p-6 fade-in"
      onClick={onClose} data-testid="file-preview">
      <div className="bg-white rounded-lg max-w-6xl w-full h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="h-14 border-b border-slate-200 flex items-center justify-between px-5">
          <div className="min-w-0 flex-1">
            <div className="font-bold text-slate-900 truncate" style={{ fontFamily: "Chivo" }}>{filename}</div>
            <div className="text-xs text-slate-500">{contentType}</div>
          </div>
          <div className="flex items-center gap-2">
            <a href={downloadUrl} download={filename}
              className="inline-flex items-center gap-2 h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-slate-800"
              data-testid="preview-download">
              <DownloadSimple size={16} weight="bold" /> Scarica
            </a>
            <button onClick={onClose} className="w-9 h-9 rounded flex items-center justify-center hover:bg-slate-100"
              data-testid="preview-close">
              <X size={18} />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto bg-slate-100 flex items-center justify-center p-4">
          {error && <div className="text-slate-500">{error}</div>}
          {!error && !blobUrl && <div className="text-slate-500">Caricamento…</div>}
          {blobUrl && isImage && <img src={blobUrl} alt={filename} className="max-w-full max-h-full object-contain" />}
          {blobUrl && isPdf && <iframe src={blobUrl} title={filename} className="w-full h-full bg-white" />}
        </div>
      </div>
    </div>
  );
}
